<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="showBadge"
        :content="count"
        class="white--text"
        color="primary"
      >
        <v-btn v-bind="attrs" v-on="on" color="primary" small outlined>
          <v-icon dense x-small left>fa-sort-amount-down</v-icon>
          Ordenar
        </v-btn>
      </v-badge>
    </template>
    <div class="menu__content">
      <v-list>
        <v-list-item
          v-for="(sort, index) in pagamentoItensSorting"
          :key="index"
        >
          <div class="d-flex align-center">
            <v-select
              @change="event => updateSortValue(index, event)"
              :items="sortingColumnsValues"
              :value="sort.value"
              :style="'width: 240px'"
              class="mr-2"
              outlined
              dense
              hide-details
            />
            <v-select
              @change="event => updateSortDirection(index, event)"
              :items="sortingOrderValues"
              :value="sort.direction"
              :style="'width: 150px'"
              class="mr-2"
              outlined
              dense
              hide-details
            />
            <v-btn
              @click="() => removeSort(index)"
              icon
            >
              <v-icon small>fa-times</v-icon>
            </v-btn>
          </div>
        </v-list-item>
      </v-list>
      <v-btn
        @click="addNewSort"
        color="primary"
        class="mx-4 mb-4"
      >
        <v-icon left small>fa-plus</v-icon>
        Adicionar
      </v-btn>
    </div>
  </v-menu>
</template>

<style scoped>
.menu__content {
  background-color: white;
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  data () {
    return {
      sortingColumnsValues: [
        { text: 'Valor informado', value: 'valorInformado' },
        { text: 'Valor processado', value: 'valorProcessado' },
        { text: 'Valor pago', value: 'valorPago' },
        { text: 'Valor glosado', value: 'valorGlosado' },
        { text: 'Data execução', value: 'dataExecucao' },
        { text: 'Código procedimento', value: 'codigoProcedimento' },
        { text: 'Descrição procedimento', value: 'descricaoProcedimento' },
        { text: 'Código tabela', value: 'codigoTabela' }
      ],
      sortingOrderValues: [
        { text: 'Crescente', value: 'asc' },
        { text: 'Decrescente', value: 'desc' }
      ]
    }
  },
  computed: {
    ...mapState('conciliacao', ['pagamentoItensSorting']),
    count () {
      return this.pagamentoItensSorting
        .filter(sort => Boolean(sort.value))
        .length
    },
    showBadge () {
      return this.count > 0
    }
  },
  methods: {
    addNewSort () {
      this.$store.dispatch('conciliacao/addPagamentoItensSortingValue', { value: null, direction: 'asc' })
    },
    removeSort (index) {
      this.$store.dispatch('conciliacao/removePagamentoItensSortingValueByIndex', index)
    },
    updateSortValue (index, newValue) {
      this.$store.dispatch('conciliacao/updatePagamentoItensSortingValue', { index, value: newValue })
    },
    updateSortDirection (index, newDirection) {
      this.$store.dispatch('conciliacao/updatePagamentoItensSortingDirection', { index, direction: newDirection })
    }
  }
}
</script>
